module.exports = __webpack_public_path__ + "static/media/06.711c50e7.png";